import { Instance, types } from 'mobx-state-tree'
import { AuthenticationStoreModel } from 'models/authentication-store/authentication-store'
import { LivesStoreModel } from 'models/lives-store'

export const RootStoreModel = types.model('RootStore', {
  livesStore: types.optional(LivesStoreModel, {}),
  authStore: types.optional(AuthenticationStoreModel, {}),
})

export interface RootStore extends Instance<typeof RootStoreModel> {}
